import Script from 'next/script'
import { useExperimentService } from '../../../lib/hooks'

// the OptanonWrapper function is called after banner script execution.
// Please refer to https://my.onetrust.com/s/article/UUID-29158b4e-22f6-0067-aa36-94f3b8cf3561?language=en_US
const oneTrustBannerInitCallback = `function OptanonWrapper() {
  // add event listener to OneTrust consent activities
  // C0004 is the group id for targeted cookie group in OneTrust. which should be associated to ad_storage in MCM
  window.OneTrust?.OnConsentChanged(function() {
      window.uetq = window.uetq || [];
      window.uetq.push('consent', 'update', {
        'ad_storage': window.OnetrustActiveGroups?.includes('C0004') ? 'granted' : 'denied'
      });
  });
}`

/**
 * These scripts are generated by OneTrust Admin tool. We use OneTrust for displaying a cookie banner to be GDPR compliant.
 * If they need to be updated, please use OneTrust Admin tool to publish a new script and then use here.
 * The same script is used in Blog and Funnel.
 * Strategy is set to beforeInteractive so we can block other pieces of JS from running since we cannot add scripts to
 * head in Next.JS
 */
export const OneTrustScripts = () => {
  const { isGDPR, isOneTrustTestScript } = useExperimentService()
  const oneTrustConfigId = isOneTrustTestScript
    ? 'c6c558ad-cd49-418e-af8a-61680371a5f2-test'
    : 'c6c558ad-cd49-418e-af8a-61680371a5f2'

  // the default consent settings for Google Consent Mode according to
  // https://my.onetrust.com/s/article/UUID-d81787f6-685c-2262-36c3-5f1f3369e2a7
  const defaultCM = isGDPR ? 'denied' : 'granted'
  const oneTrustConsentModeDefault = `
    // Define dataLayer and the gtag function for Google Consent Mode
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent', 'default', {
          'ad_storage': '${defaultCM}',
          'analytics_storage': '${defaultCM}',
          'functionality_storage': '${defaultCM}',
          'personalization_storage': '${defaultCM}',
          'security_storage': '${defaultCM}',
          'ad_user_data': '${defaultCM}',
          'ad_personalization': '${defaultCM}',
          'wait_for_update': 500
    });

    // define default settings for Microsoft Consent Mode
    // https://help.ads.microsoft.com/?FromAdsEmail=1#apex/ads/en/60119/1-500
    window.uetq = window.uetq || [];
    window.uetq.push('consent', 'default', {
    'ad_storage': '${defaultCM}'
    });
    `

  return (
    <>
      <Script
        id="onetrust-gcm-default-consent"
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: oneTrustConsentModeDefault }}
        strategy="beforeInteractive"
        data-ot-ignore
        defer={false}
      />
      <Script
        id="onetrust-otautoblock"
        type="text/javascript"
        src={`https://cdn.cookielaw.org/consent/${oneTrustConfigId}/OtAutoBlock.js`}
        strategy="beforeInteractive"
        data-ot-ignore
        defer={false}
      />
      <Script
        id="onetrust-otsdkstub"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script={oneTrustConfigId}
        defer={false}
        strategy="beforeInteractive"
        data-ot-ignore
      />
      <Script
        id="onetrust-bannerinit"
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: oneTrustBannerInitCallback }}
        defer={false}
        strategy="beforeInteractive"
        data-ot-ignore
      />
    </>
  )
}
